import { Typography, Box, Tooltip } from "@mui/material";

interface CustomerAppLabelProps {
    name: string;
    email?: string;
    document?: string;
}

export function PayerInfoLabel({
    name,
    email,
    document,
}: CustomerAppLabelProps) {
    const tooltipContent = [name, document, email].filter(Boolean).join(" / ");

    return (
        <Tooltip title={tooltipContent} placement="top">
            <Box sx={{ overflow: "hidden" }}>
                <Typography variant="body2" noWrap>
                    {name}
                </Typography>
                <Box display="flex" flexDirection="column">
                    {email && (
                        <Typography variant="caption" color="GrayText" noWrap>
                            {document} / {email}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Tooltip>
    );
}
